<template>
  <div>
    <div class="mx-1">
      <growth-chart
        primary
        :data="insightData['CustomerGrowth']"
        title="Customer growth"
        value-title="New Customer Count"
        value-name="New Customers"
        aggregation-title="Total Customer Count"
        aggregation-name="Cumulative Customers"/>
    </div>

    <masonry :key="insightComputationKey">
      <customer-age-counts
        v-if="insightData['CustomerAgeCounts']"
        :values="insightData['CustomerAgeCounts']"/>

      <date-insight
        v-for="dateInsight in dateInsights"
        :key="dateInsight['slug']"
        v-bind="dateInsight"
        :data-file-type="dataFileType"/>

      <categorical-insight
        v-for="counts in categoricalValueCounts"
        :key="counts['slug']"
        v-bind="counts"
        title="Customer Count"/>

      <single-value-insights
        :values="categoricalSingleValuedData"/>
    </masonry>
  </div>
</template>

<script>
  import GrowthChart from './GrowthChart';
  import CategoricalInsight from './CategoricalInsight';
  import CustomerAgeCounts from './CustomerAgeCounts';
  import SingleValueInsights from './SingleValueInsights';
  import DateInsight from './DateInsight';
  import {defaultValues, fetchInsight} from './utils';
  import CategoricalInsightMixin from './CategoricalInsightsMixin';
  import InsightsComputationMixin from './InsightsComputationMixin';
  import DateInsightsMixin from './DateInsightsMixin';
  import Masonry from './Masonry';

  const INSIGHTS = 'CustomerGrowth|CustomerAgeCounts'.split('|');

  export default {
    name: 'CustomersTab',

    mixins: [
      CategoricalInsightMixin,
      InsightsComputationMixin,
      DateInsightsMixin
    ],

    components: {
      CategoricalInsight,
      CustomerAgeCounts,
      GrowthChart,
      SingleValueInsights,
      DateInsight,
      Masonry
    },

    data() {
      return {
        insightData: defaultValues(INSIGHTS),
      };
    },

    methods: {
      resetInsightsData() {
        this.insightData = defaultValues(INSIGHTS);
        this.resetCategoricalData();
        this.resetDateInsights();
      },

      computeInsightsData() {
        INSIGHTS.forEach(key => {
          fetchInsight(key, this.filter)
            .then(data => {
              this.insightData[key] = data;
            });
        });

        this.fetchCategoricalData(this.filter);
        this.fetchDateInsights(this.filter);
      },
    },

    computed: {
      dataFileType() {
        return 'Customer';
      }
    }
  };
</script>
